<template>
  <div class="container">
    <div class="news-page">
      <section class="news-timeline py-5">
        <div class="container">
          <h1 class="text-center mb-5">Aktuelle Nachrichten</h1>
          <div class="timeline">
            <div class="timeline-item" v-for="(news, index) in visibleNews" :key="index">
              <div class="timeline-date">
                <span>{{ news.month }}</span> <span>{{ news.year }}</span>
              </div>
              <div class="timeline-content news-card">
                <div class="card-body d-flex flex-column align-items-center justify-content-center">
                  <h5 class="card-title text-center">{{ news.title }}</h5>
                  <p class="card-text" v-html="news.excerpt"></p>
                  <div v-if="index === 0 && news.youtubeId" class="youtube-video-container mt-3">
                    <iframe
                      width="560"
                      height="315"
                      :src="'https://www.youtube.com/embed/' + news.youtubeId"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center mt-4" v-if="showLoadMoreButton">
            <button @click="loadMore" class="btn btn-primary">Mehr anzeigen</button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>


<script>
export default {
  name: 'AppNews',
  data() {
    return {
      newsItems: [
		{
    "title": "Jahres Endspurt",
    "excerpt": "Das Jahr neigt sich dem Ende zu und wir blicken auf ein erfolgreiches Jahr 2024 zurück. Wir konnten zahlreiche spannende Projekte abschließen, neue Kunden gewinnen und unser Dienstleistungsportfolio erweitern. Wir bedanken uns bei allen Kunden, Partnern und Mitarbeitern für ihr Vertrauen und ihre Unterstützung. Wir freuen uns auf ein ebenso erfolgreiches Jahr 2025 und wünschen allen ein frohes Fest und einen guten Rutsch ins neue Jahr!", 
    "month": "Dezember",
    "year": "24",
    "youtubeId": "", 

  },
		{
    "title": "Verlässliche Partnerschaften für 2025",
    "excerpt": "Einer unser wichtigstens Kunden hat uns für das Jahr 2025 erneut das Vertrauen geschenkt und unseren Servicevertrag verlängert. Wir freuen uns darauf, auch in Zukunft an spannenden Projekten zusammenzuarbeiten und innovative Lösungen zu entwickeln. Diese Partnerschaft ist ein Beweis für unser Engagement, unseren Kunden stets den bestmöglichen Service zu bieten.",
    "month": "November",
    "year": "24",
    "youtubeId": "", 

  },
		{
    "title": "Neue Preisstruktur für 2025 für ein noch besseres Kundenerlebnis",
    "excerpt": "Diesen Monat haben wir unsere Preise und Pakete komplett überarbeitet, um mehr Transparenz zu schaffen. Unser Ziel ist es, Ihnen ein noch besseres Kundenerlebnis zu bieten. Die neuen Preise sind ab sofort gültig und gelten sowohl für neue als auch für bestehende Kunden.",
    "month": "Oktober",
    "year": "24",
    "youtubeId": "", 

  },
		{
    "title": "Erstellung von Schulungsvideos mit AI-Technologie",
    "excerpt": "Wir haben für einen Kunden 60 Stunden Schulungsvideos mithilfe von AI-Technologie optimiert, indem wir sie gekürzt, transkribiert, in mehrere Sprachen übersetzt und mit professionellen Sprachaufnahmen sowie einem AI-Avatar versehen haben, um den Onboarding-Prozess effizienter zu gestalten.",
    "month": "September",
    "year": "24",
    "youtubeId": "YigA_uPD_qQ/",

  },
		{
    "title": "Umzug nach Planegg und Website-Relaunch",
    "excerpt": "Im August 2024 haben wir einen bedeutenden Meilenstein erreicht: den erfolgreichen Umzug nach Planegg. Unsere neuen Räumlichkeiten bieten uns nicht nur mehr Platz, sondern auch neue Möglichkeiten für Wachstum und Innovation. Gleichzeitig haben wir unsere Website komplett neu gestaltet, um Ihnen ein noch besseres Nutzererlebnis zu bieten. Entdecken Sie die vielen neuen Features und freuen Sie sich auf einen frischen, modernen Look.",
    "month": "August",
    "year": "24",
    "youtubeId": "",
  },
  {
    "title": "Erfolgreicher Launch einer Lager-App",
    "excerpt": "Im Juli 2024 haben wir für einen führenden Kunden aus der Metallverarbeitung eine innovative mobile App entwickelt, die die Erfassung von Lagerbewegungen revolutioniert. Diese App, die mit Flutter und Firebase realisiert wurde, bietet eine intuitive und benutzerfreundliche Lösung, die die Effizienz der Lagerverwaltung erheblich steigert. Wir sind stolz darauf, Teil dieses erfolgreichen Projekts zu sein.",
    "month": "Juli",
    "year": "24"
  },
  {
    "title": "Planung des Umzugs nach Planegg",
    "excerpt": "Die Planung für unseren Umzug nach Planegg ist in vollem Gange. Wir freuen uns auf die neuen Räumlichkeiten, die uns nicht nur mehr Platz, sondern auch bessere Möglichkeiten für unsere Projekte bieten werden. Der Umzug markiert einen wichtigen Schritt in unserem Wachstum, und wir sind gespannt auf die Chancen, die uns dieser neue Standort eröffnen wird.",
    "month": "Juni",
    "year": "24"
  },
  {
    "title": "Redesign der GitLab-Pipeline",
    "excerpt": "Im Mai 2024 haben wir für einen unserer größten Kunden eine umfassende Neugestaltung der GitLab-Pipeline vorgenommen. Ziel war es, eine Zero Down Time Deployment-Pipeline zu entwickeln, die nahtlose Updates ermöglicht. Das Projekt war ein voller Erfolg und hat uns wertvolle Einblicke in neue Technologien und Best Practices geliefert. Wir freuen uns darauf, dieses Wissen in zukünftigen Projekten anzuwenden.",
    "month": "Mai",
    "year": "24"
  },
  {
    "title": "Umstellung von Docker Swarm auf Kubernetes",
    "excerpt": "Im April 2024 haben wir für einen unserer Kunden die Migration von Docker Swarm auf Kubernetes erfolgreich abgeschlossen. Dieser Wechsel verbessert die Skalierbarkeit und Zuverlässigkeit der Anwendungen erheblich und stellt sicher, dass die Infrastruktur für zukünftige Herausforderungen bestens gerüstet ist. Dieses Projekt zeigt unsere Fähigkeit, komplexe IT-Umstellungen effizient und sicher durchzuführen.",
    "month": "April",
    "year": "24"
  },
  {
    "title": "Neuer Kunde aus dem Bereich Medizin",
    "excerpt": "Im März 2024 durften wir einen neuen Kunden aus der Medizinbranche begrüßen. Das Projekt umfasst die Entwicklung einer webbasierten Schnittstelle zur Anbindung von GDT- und ADT-basierten Systemen. Diese Integration wird die Effizienz und Datenintegrität erheblich verbessern und zeigt unser Engagement, innovative Lösungen für die Gesundheitsbranche zu entwickeln.",
    "month": "März",
    "year": "24"
  },
  {
    "title": "Erweiterung des Portfolios um KI-Tools",
    "excerpt": "Im Februar 2024 haben wir unser Dienstleistungsportfolio um modernste KI-Tools erweitert. Mit diesen neuen Technologien möchten wir unseren Kunden noch bessere Lösungen zur Automatisierung und Optimierung ihrer Geschäftsprozesse bieten. Dieser Schritt unterstreicht unser Bestreben, stets an der Spitze technologischer Entwicklungen zu stehen und innovative Wege zu beschreiten.",
    "month": "Februar",
    "year": "24"
  },
  {
    "title": "Ausbau der Zusammenarbeit mit einem Bestandskunden",
    "excerpt": "Zu Beginn des Jahres 2024 konnten wir die Zusammenarbeit mit einem unserer geschätzten Bestandskunden erheblich ausweiten. Wir sind nun verantwortlich für die gesamte IT-Infrastruktur-Strategie und deren Umsetzung. Dieses erweiterte Mandat zeigt das Vertrauen, das unsere Kunden in unsere Expertise und unsere Fähigkeit setzen, maßgeschneiderte IT-Lösungen zu liefern.",
    "month": "Januar",
    "year": "24"
  }
        // Weitere News-Items können hier hinzugefügt werden
      ],
      visibleNews: [],
      newsPerPage: 8,
      currentPage: 1
    };
  },
  computed: {
    showLoadMoreButton() {
      return this.visibleNews.length < this.newsItems.length;
    }
  },
  mounted() {
    this.loadMore();
  },
  methods: {
    loadMore() {
      const nextPageNews = this.newsItems.slice(
        this.visibleNews.length,
        this.visibleNews.length + this.newsPerPage
      );
      this.visibleNews = [...this.visibleNews, ...nextPageNews];
      this.currentPage++;
    }
  }
};
</script>


<style lang="scss" scoped>
@import "@/assets/css/global.scss";

.news-timeline {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 0;
}

.timeline {
  position: relative;
  padding: 20px 0;
  list-style-type: none;
}

.timeline::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 10%;
  width: 2px;
  background-color: $secondary-color;
}

.timeline-item {
  position: relative;
  display: flex;
  align-items: center;
  margin: 20px 0;
}

.timeline-date {
  flex: 0 0 15%;
  text-align: center;
  font-weight: bold;
  background: $primary-color;
  border: 2px solid $primary-color;
  border-radius: 4px;
  padding: 5px;
}

.timeline-content {
  flex: 0 0 80%;
  margin-left: 20px;
  background: linear-gradient($primary-color, $secondary-color, $primary-color);
  border-radius: 15px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  padding: 15px;
  text-align: left;
}

.news-card:hover {
  transform: scale(1.05);
  box-shadow: 0px 12px 30px rgba(0, 0, 0, 0.3);
}

.card-title {
  margin-bottom: 10px;
  font-size: 1.25rem;
  font-weight: bold;
  text-align: center;
}

.card-text {
  font-size: 1rem;
  color: $accent-color;
  white-space: pre-wrap; /* Ermöglicht das Einfügen neuer Zeilen */
}


.youtube-video-container {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* 16:9 Aspect Ratio */
  height: 0;
  overflow: hidden;
}

.youtube-video-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
